import { CommonStyles, TextStyles } from 'cms/cms-shared/common-settings-styles/common-settings-styles.models';
import { IdtComponentSettings } from 'shared/idt-components/idt-components-cms.model';


export type TypeTextShadow = 'none' | 'first-text-shadow' | 'second-text-shadow' | 'third-text-shadow';

export interface PieceTextSettings extends IdtComponentSettings {
  general: PieceTextSettingsGeneral;
  styles: Omit<CommonStyles, 'shadow'> & TextStyles;
}

export interface TextPaddingSettings {
  // TODO: refactor this interface to remove numbers
  textPaddingTop: string | number;
  textPaddingBottom: string | number;
  textPaddingLeft: string | number;
  textPaddingRight: string | number;
}

export interface MarqueeSettings {
  marqueeStatus?: boolean;
  marqueeDurationDesktop?: number;
  marqueeDurationMobile?: number;
}

export interface DropdownModeSettings {
  status: boolean;
  seeMoreText: string;
  seeLessText: string;
  linesSummaryDesktop: number;
  linesSummaryMobile: number;
}

export const TextPaddingDefaultSettings: TextPaddingSettings = {
  textPaddingBottom: '0px',
  textPaddingLeft: '0px',
  textPaddingRight: '0px',
  textPaddingTop: '0px',
};

export interface PieceTextSettingsGeneral extends TextPaddingSettings {
  text: string;
  textMobile?: string;
  enableByDevice?: boolean;
  textPositionVertical?: 'up' | 'middle' | 'down';
  shadow?: TypeTextShadow;
  marquee?: MarqueeSettings;
  textDropdownMode?: DropdownModeSettings;
  blink?: boolean;
}
